/* eslint-disable @typescript-eslint/no-explicit-any */

import { createExercise } from '@datacamp/campus-integration';
import { constants, utils } from '@datacamp/chat-exercise-core';
import { applyMiddleware, compose, createStore } from 'redux';
import reduxThunk from 'redux-thunk';
import setExerciseEntity from './actions/actionCreators/exerciseEntityUpdated';
import Shell from './components/Shell';
import config, { USED_AS_SPA } from './config';
import { sentry } from './lib/sentry';
import glossaryDe from './locales/de-DE/glossary.json';
import de from './locales/de-DE/translation.json';
import glossaryEn from './locales/en/glossary.json';
import en from './locales/en/translation.json';
import glossaryEs from './locales/es/glossary.json';
import es from './locales/es/translation.json';
import glossaryFr from './locales/fr-FR/glossary.json';
import fr from './locales/fr-FR/translation.json';
import glossaryIt from './locales/it-IT/glossary.json';
import it from './locales/it-IT/translation.json';
import glossaryPt from './locales/pt-BR/glossary.json';
import pt from './locales/pt-BR/translation.json';
import glossaryTr from './locales/tr-TR/glossary.json';
import tr from './locales/tr-TR/translation.json';
import reducers from './reducers';
function isDefinedObject(obj) {
  return typeof obj === 'object';
}
function hasExt(obj) {
  return !!obj;
}
const win = global;
const composeEnhancers = USED_AS_SPA && isDefinedObject(win) && hasExt(win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));
const App = createExercise({
  config,
  requireAuthenticatedUser: true,
  sentryInstance: sentry,
  setExerciseEntity,
  store,
  translations: {
    de: {
      glossary: glossaryDe,
      translation: de
    },
    en: {
      glossary: glossaryEn,
      translation: en
    },
    es: {
      glossary: glossaryEs,
      translation: es
    },
    fr: {
      glossary: glossaryFr,
      translation: fr
    },
    it: {
      glossary: glossaryIt,
      translation: it
    },
    pt: {
      glossary: glossaryPt,
      translation: pt
    },
    tr: {
      glossary: glossaryTr,
      translation: tr
    }
  },
  type: constants.exercises.CHAT_EXERCISE,
  validate: utils.exerciseTypeVersionAdapter
})(Shell);
export default App;